import { TRootState, TJuridicalPersonsState } from '../../types'
import { createSelector } from '@reduxjs/toolkit'
import { juridicalPersonsAdapter } from './adapter'

const selectState = (state: TRootState): TJuridicalPersonsState => state.juridicalPersons

const adapterSelectors = juridicalPersonsAdapter.getSelectors(selectState)

const fetchStatus = createSelector(
    selectState,
    (state) => ({
        isFetching: state.isFetching,
        error: state.fetchError,
    })
)

const totalItems = createSelector(
    selectState,
    (state) => (state.totalItems)
)

export const selectors = {
    ...adapterSelectors,
    fetchStatus,
    totalItems,
}